import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appUppercase]'
})
export class UppercaseDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const upperValue = input.value.toUpperCase();

    this.control.control?.setValue(upperValue, { emitEvent: false });
    input.value = upperValue;

    // Restore cursor position
    if (start !== null && end !== null) {
      input.setSelectionRange(start, end);
    }
  }
}